module.exports = __webpack_public_path__ + "static/media/elephant-rider.2bb4a71c.jpg";